'use client'

import { useEffect, useState } from 'react'
import useScrollProgress from '@/lib/useScrollProgress'
import {
  DirectionType,
  useDirectionContext,
} from '@/components/common/DirectionSelect'

const ScrollProgress = () => {
  const [mounted, setMounted] = useState(false)
  const { direction } = useDirectionContext()
  const progress = useScrollProgress()
  const progressWithDirection =
    direction === 'ltr' ? progress - 100 : 100 - progress

  useEffect(() => {
    setMounted(true)
    return () => setMounted(false)
  }, [])

  if (!mounted) {
    // Skeleton
    // NOTE: Because the position of the scroll progress is absolute, a skeleton is not needed.
    return null
  }

  /*
   ** NOTE: Must use style attribute instead of having TailwindCSS construct a dynamic class name.
   ** TailwindCSS rule: Don’t use props to build class names dynamically.
   ** Class names must be statically detectable at build-time.
   ** https://tailwindcss.com/docs/content-configuration#dynamic-class-names
   */
  return (
    <span
      style={{ transform: `translateX(${progressWithDirection}%)` }}
      className="absolute bg-current h-0.5 w-full bottom-px"
    />
  )
}

export default ScrollProgress
